import { v4 } from 'uuid';
export const slugify = (key) => `${key}${v4().substring(0, 5)}`;
